import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import CountryTableContainer from '../containers/country-table.container';
import CountryDetailsContainer from '../containers/country-details.container';
import CountryCreateContainer from '../containers/country-create.container';
import CountryUpdateContainer from '../containers/country-update.container';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../../../../../const/default-paginated-table-data.const';

// Helper function to add default query parameters to the country list page
const CountryListWithParams = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Set default params if they don't exist
  if (!params.has('page')) {
    params.set('page', DEFAULT_PAGINATION_PAGE.toString());
  }
  if (!params.has('limit')) {
    params.set('limit', DEFAULT_PAGINATION_LIMIT.toString());
  }

  // If query params need to be added
  if (location.search !== `?${params.toString()}`) {
    return <Navigate to={`?${params.toString()}`} replace />;
  }

  return <CountryTableContainer />;
};

export const countryRoutes = [
  {
    path: 'admin/country/',
    element: <CountryListWithParams />,
  },
  {
    path: 'admin/country/create',
    element: <CountryCreateContainer />,
  },
  {
    path: 'admin/country/:id',
    element: <CountryDetailsContainer />,
  },
  {
    path: 'admin/country/:id/update',
    element: <CountryUpdateContainer />,
  },
];

export default countryRoutes;
